module.exports = __webpack_public_path__ + "static/media/highlights (2).d333bc7a.jpg";